export const SET_IS_AUTHORIZE: string = 'SET_IS_AUTHORIZE';
export const SET_IS_AUTHCHECKING: string = 'SET_IS_AUTHCHECKING';
export const UNAUTHORIZE_API: string = 'UNAUTHORIZE_API';
export const SET_USERDATA: string = 'SET_USERDATA';
export const PRODUCTS_LOADED: string = 'PRODUCTS_LOADED';